import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {InvoiceDashboard, InvoicePaymentHistory, VendorInvoicePayment, VendorInvoicePaymentInfo} from "@app/finance/accounts-payable/ap-main/ap-main";
import {BLOB_RESPONSE_TYPE, InvoiceSummary, QueryResult} from "@app/shared";


@Injectable()
export class AccountsPayableService {
  constructor(private http: HttpClient) {
  }

  private getInvoice = `/accounts-payable/invoices`;
  private getHistory = `/accounts-payable/invoices/payment-history?invoiceId=`;
  private getCreditCardsUrl = `/payments/credit-cards`;
  private getBankDetailsUrl = `/payments/ach-details`;
  private deleteURL = '/accounts-payable/invoices';
  private getEligibilityUrl = '/accounts-payable/invoices/payment-eligibility';
  private getAllocationChargeCodeUrl = '/accounts-payable/invoices/charge-code-summary';


  getPayableDashboard(): Observable<InvoiceDashboard> {
    const url = "/accounts-payable/dashboard";

    return this.http.get<InvoiceDashboard>(url);
  }

  getReceiptReturnSummary(invoiceId?: number, purchaseOrderId?: number, receiptId?: number, referenceNumber?: string): Observable<InvoiceSummary[]> {
    let url = `/accounts-payable/invoice-mapping/receipt-return-mapping`;

    if (invoiceId) {
      url += '?invoiceId=' + invoiceId;
    } else if (purchaseOrderId) {
      url += '?purchaseOrderId=' + purchaseOrderId;
    } else if (receiptId) {
      url += '?receiptId=' + receiptId;
    } else if (referenceNumber) {
      url += '?referenceNumber=' + referenceNumber;
    }
    return this.http.get<InvoiceSummary[]>(url);
  }

  //delete invoice by id
  deleteInvoice(id: number): Observable<any> {
    return this.http.delete<any>(`${this.deleteURL}/${id}`);
  }

  //search vendor by invoice
  searchInvoiceSummary(queryParams: string): Observable<QueryResult> {
    const url = `/accounts-payable/summary?${queryParams}`;
    return this.http.get<QueryResult>(url);
  }

  // get invoice using invoice id
  getInvoiceById(id: number): Observable<any> {
    return this.http.get<any>(`${this.getInvoice}/${id}`);
  }

  getInvoicePaymentAmountDetails(id: number, paymentDate: string, paymentAmount: number, applyDiscount: boolean, applyInterest: boolean): Observable<VendorInvoicePaymentInfo> {
    let url = `/accounts-payable/invoices/adjusted-payment?invoiceId=${id}&paymentDate=${paymentDate}&paymentAmount=${paymentAmount}&applyDiscount=${applyDiscount}&applyInterest=${applyInterest}`;
    return this.http.get<VendorInvoicePaymentInfo>(`${url}`);
  }

  // get payment history
  getPaymentHistory(id: number): Observable<InvoicePaymentHistory> {
    return this.http.get<InvoicePaymentHistory>(`${this.getHistory}${id}&count=-1`);
  }

  // get pdf data
  savePDF(txnType: string, refId: number): Observable<any> {
    const url = '/pdf';

    return this.http.get(`${url}?transaction=${txnType}&refId=${refId}`, {observe: 'response', responseType: BLOB_RESPONSE_TYPE});
  }

  //save payment data TO PAYMENT TABLE
  savePayment(payment: VendorInvoicePayment): Observable<any> {
    const url = `/accounts-payable/invoices/payments`;

    return this.http.post<any>(url, payment);
  }

  //get invoicePaymentEligibility
  getEligibility(id: number): Observable<any> {
    return this.http.get<any>(`${this.getEligibilityUrl}?invoiceId=${id}`);
  }

  //retrieve credit cards for payment
  getCreditCards(): Observable<any> {
    // return this.http.get<any>(`${this.getCreditCardsUrl}/${id}`);
    return this.http.get<any>(`${this.getCreditCardsUrl}`);
  }

  //retrieve bank details for payment
  getBankDetails(): Observable<QueryResult> {
    return this.http.get<QueryResult>(`${this.getBankDetailsUrl}`);
  }

  getAllocationChargeCode(invoiceId: string): Observable<any> {
    return this.http.get<any>(`${this.getAllocationChargeCodeUrl}?invoiceId=${invoiceId}`);
  }

  getCreditFormValue(invoiceId: number): Observable<any> {
    const url = `/accounts-payable/invoices/payment-credit?invoiceId=${invoiceId}`;

    return this.http.get<any>(url);
  }

}
